// src/views/balances/actions/components/ContractActionsList.js
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  selectContractActionsList,
  selectContractActionsListCount,
  selectContractActionsQueryOptions
} from 'src/store/selectors/contractActionsSelectors';
import {
  loadContractActions,
  LOAD_CONTRACT_ACTIONS
} from 'src/store/actions/contractActionsActions';
import ContractActionsTable from './ContractActionsTable';

const useStyles = makeStyles()(() => ({
  prealoderCard: {
    minHeight: '80vh'
  }
}));

export const ContractActionsList = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const contractActions = useSelector(selectContractActionsList);
  const count = useSelector(selectContractActionsListCount);
  const { page } = useSelector(selectContractActionsQueryOptions);
  const loading = useSelector(
    isLoadingSelector([LOAD_CONTRACT_ACTIONS.action])
  );
  const success = useSelector(
    successSelector([LOAD_CONTRACT_ACTIONS.action])
  );

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(loadContractActions({ page: value }));
    },
    [dispatch]
  );

  if (success && !loading && count === 0) {
    return (
      <Card className={classes.prealoderCard}>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.CONTRACT_ACTIONS_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.CONTRACT_ACTIONS_DESCRIPTION"
        />
      </Card>
    );
  }

  return (
    <ContractActionsTable
      contractActions={contractActions}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

export default ContractActionsList;
